window.sticky = ($element) => {
    return {
        header: document.querySelector("header"),
        metaNavigation: document.querySelector(".meta-navigation"),
        navHeight: 0,
        element: $element,
        init() {

            this.setHeight();
            window.addEventListener("resize", () => {
                this.setHeight();
            });
        },
        setHeight() {
            if (this.header) {
                this.navHeight = this.header.clientHeight;
            }

            if (this.metaNavigation) {
                this.navHeight += this.metaNavigation.clientHeight;
            }

            this.element.style.top = this.navHeight + 20 + "px";
        }
    };
};